import {
  PPM_GET_AGGREGATE_REQUEST,
  PPM_GET_AGGREGATE_SUCCESS,
  PPM_GET_AGGREGATE_FAILURE,
  PPM_GET_AGGREGATE_RANGE_REQUEST,
  PPM_GET_AGGREGATE_RANGE_SUCCESS,
  PPM_GET_AGGREGATE_RANGE_FAILURE,
  PPM_SET_DATERANGE_FILTERS_SUCCESS
} from './actions';

import _ from 'lodash';

import createReducer from 'state/createReducer';

const initialState = {
  aggregate: {
    request: false,
    data: null
  },
  aggregateRange: {
    request: false,
    data: []
  }
};

const handlers = {
  [PPM_GET_AGGREGATE_REQUEST](state) {
    return {
      ...state,
      aggregate: {
        ...state.aggregate,
        request: true
      }
    };
  },

  [PPM_GET_AGGREGATE_SUCCESS](state, payload) {
    return {
      ...state,
      aggregate: {
        request: false,
        data: payload
      }
    };
  },

  [PPM_GET_AGGREGATE_FAILURE](state, payload) {
    return {
      ...state,
      aggregate: {
        ...state.aggregate,
        request: false
      }
    };
  },
  [PPM_GET_AGGREGATE_RANGE_REQUEST](state) {
    return {
      ...state,
      aggregateRange: {
        ...state.aggregateRange,
        request: true
      }
    };
  },

  [PPM_GET_AGGREGATE_RANGE_SUCCESS](state, payload) {
    return {
      ...state,
      aggregateRange: {
        request: false,
        data: payload
      }
    };
  },

  [PPM_GET_AGGREGATE_RANGE_FAILURE](state, payload) {
    return {
      ...state,
      aggregateRange: {
        ...state.aggregateRange,
        request: false
      }
    };
  },

  [PPM_SET_DATERANGE_FILTERS_SUCCESS](state, payload) {
    const newActiveFilters = { ...state.activeFilters };
    newActiveFilters['daterange'] = {
      startDate: payload.startDate,
      endDate: payload.endDate
    }

    return {
      ...state,
      activeFilters: newActiveFilters
    }
  }
};

export default (state = initialState, action) => createReducer(state, action, handlers);